import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './Slideshow.css';

/**
 * Slideshow with images and text.
 *
 * @param {object} props
 * @param {Array<{ imagee: string, text: string }>} props.slides
 */
export const slideshow = (props) => {
  const settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 2000
  };

  const slides = props.slides.map(slide => (
    <div key={slide.image}>
      <img src={slide.image} alt={slide.text} />
      <div className="subtitle">
        {slide.text}
      </div>
    </div>
  ));

  return (
    <div className="Slideshow">
      <Slider {...settings}>
        {slides}
      </Slider>
    </div>
  );
};

slideshow.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired
};

export default slideshow;



// WEBPACK FOOTER //
// ./src/Slideshow/Slideshow.js